import { ProjectMap } from '@core/entities/project/ProjectMap'
import {
  projectMapsKeys,
  RequestTypes,
} from '@core/react-query/features/projects/maps'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useUpdateProjectMapConfiguration = (
  options?: UseMutationOptions<
    ProjectMap,
    RequestErrorType,
    RequestTypes['updateProjectMapConfiguration']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectMapsKeys.updateProjectMapConfiguration,
    ...options,
    onSuccess: (data, variables, context) => {
      options?.onSuccess && options?.onSuccess(data, variables, context)
      queryClient.invalidateQueries({
        queryKey: projectMapsKeys.byProjectMapConfiguration({
          projectId: variables.projectId,
        }).queryKey,
      })
    },
  })
}
